import React from "react";
import Profile from "../../_metronic/components/SuperAdmin/Profile/Profile.js";
import News from "../../_metronic/components/News/News.js";
import Kontaktdetails from "../../_metronic/components/Kontaktdetails/Kontaktdetails.js";
import Anfragedetails from "../../_metronic/components/AnfrageDetails/Anfragedetails.jsx";
import FunnelResponse2 from "../../_metronic/components/FunnelResponse2/FunnelResponse2.jsx";
import Adminmitteilungen from "../../_metronic/components/mitteilungenAdmin/index.jsx";
import ContactUSPage from "../../_metronic/components/contactUs/index.jsx";
import Locations from "../../_metronic/components/locations/index.jsx";
import EventsData from "../../_metronic/components/eventsData/index.jsx";
import LocationDetails from "../../_metronic/components/LocationDetails/index.jsx";
import { ContentRoute } from "../../_metronic/layout/index.js";
import DashboardPage from "../pages/DashboardPage.js";
import VattenfallLeads from "../../_metronic/components/vattenfallLeads/index.jsx";
import GoogleMap from "../../_metronic/components/GoogleMap";
import VattenfallLeadsMesse from "../../_metronic/components/vattenfallMesse/index.jsx";
import VattenfallPromoLeads from "../../_metronic/components/vattenfallPromo/index.jsx";
import ProjectTrello from "../../_metronic/components/ProjektTrello/index.js";
import Project from "../../_metronic/components/ProjectName/Project.jsx";
import CredentialManagement from "../../_metronic/components/CredentialManagement/CredentialManagement.jsx";
import AddParkingOwner from "../../_metronic/components/AddParkingOwner/AddParkingOwner.jsx";


export default function AdminRoleRoutes() {
  return (
    <>
      <ContentRoute exact path="/dashboard" component={DashboardPage} />
      <ContentRoute exact path="/profile" component={Profile} />
      <ContentRoute exact path="/anfrange" component={Anfragedetails} />
      {/* <ContentRoute exact path="/stepper" component={stepper} /> */}
      <ContentRoute exact path="/news" component={News} />
      <ContentRoute exact path="/kontakt" component={Kontaktdetails} />
      <ContentRoute exact path="/funnel2" component={FunnelResponse2} />
      <ContentRoute exact path="/mitteilungen" component={Adminmitteilungen} />
      <ContentRoute exact path="/locations" component={Locations} />
      <ContentRoute exact path="/google-map" component={GoogleMap} />
      <ContentRoute
        exact
        path="/location-details"
        component={LocationDetails}
      />
      <ContentRoute exact path="/events" component={EventsData} />
      <ContentRoute exact path="/vattenfall" component={VattenfallLeads} />
      <ContentRoute exact path="/contact-us" component={ContactUSPage} />
      <ContentRoute
        exact
        path="/vattenfallmesse"
        component={VattenfallLeadsMesse}
      />
      <ContentRoute
        exact
        path="/vattenfallpromo"
        component={VattenfallPromoLeads}
      />
      <ContentRoute
        exact
        path="/Parkplatzbesitzer"
        component={AddParkingOwner}
      />
      <ContentRoute exact path="/credential" component={CredentialManagement} />
      <ContentRoute exact path="/projekte-trello" component={ProjectTrello} />
      <ContentRoute exact path="/project" component={Project} />
    </>
  );
}
